import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="page-content">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto">
                        <div className="page-header text-center mb-5">
                            <h1 className="page-title gradient-text">Privacy Policy</h1>
                            <p className="page-subtitle">
                                Informativa sul trattamento dei dati personali
                            </p>
                        </div>

                        <Card className="content-card">
                            <Card.Body>
                                <h2>1. Titolare del Trattamento</h2>
                                <p>
                                    Il titolare del trattamento dei dati personali è BearSoftware di Carlo Zamponi, 
                                    con sede in Italia, P.IVA IT03341180135, 
                                    email: info@bearsoftware.it
                                </p>

                                <h2>2. Tipologie di Dati Raccolti</h2>
                                <p>
                                    Questo sito raccoglie i seguenti tipi di dati personali:
                                </p>
                                <ul>
                                    <li>Dati di contatto: nome, email, numero di telefono</li>
                                    <li>Dati di navigazione: indirizzo IP, browser, pagine visitate</li>
                                    <li>Cookie tecnici necessari per il funzionamento del sito</li>
                                </ul>

                                <h2>3. Finalità del Trattamento</h2>
                                <p>I dati personali sono trattati per le seguenti finalità:</p>
                                <ul>
                                    <li>Rispondere alle richieste di informazioni e preventivi</li>
                                    <li>Fornire i servizi richiesti</li>
                                    <li>Migliorare l'esperienza di navigazione del sito</li>
                                    <li>Adempiere agli obblighi di legge</li>
                                </ul>

                                <h2>4. Base Giuridica</h2>
                                <p>
                                    Il trattamento dei dati è basato sul consenso dell'interessato per le finalità 
                                    di marketing e sull'interesse legittimo per le finalità tecniche e di sicurezza.
                                </p>

                                <h2>5. Conservazione dei Dati</h2>
                                <p>
                                    I dati personali saranno conservati per il tempo strettamente necessario 
                                    al raggiungimento delle finalità per cui sono stati raccolti e comunque 
                                    per non oltre 24 mesi dalla raccolta, salvo diversi obblighi di legge.
                                </p>

                                <h2>6. Comunicazione dei Dati</h2>
                                <p>
                                    I dati personali non saranno comunicati a terzi, eccetto quando necessario 
                                    per l'erogazione dei servizi richiesti o per adempimenti di legge.
                                </p>

                                <h2>7. Diritti dell'Interessato</h2>
                                <p>L'interessato ha diritto di:</p>
                                <ul>
                                    <li>Accedere ai propri dati personali</li>
                                    <li>Richiedere la rettifica o la cancellazione</li>
                                    <li>Limitare il trattamento</li>
                                    <li>Opporsi al trattamento</li>
                                    <li>Richiedere la portabilità dei dati</li>
                                    <li>Revocare il consenso in qualsiasi momento</li>
                                </ul>

                                <h2>8. Cookie</h2>
                                <p>
                                    Questo sito utilizza cookie tecnici necessari per il funzionamento e cookie 
                                    di analytics per migliorare l'esperienza utente. È possibile gestire le 
                                    preferenze sui cookie attraverso le impostazioni del browser.
                                </p>

                                <h2>9. Sicurezza</h2>
                                <p>
                                    Sono implementate misure di sicurezza tecniche e organizzative appropriate 
                                    per proteggere i dati personali da accessi non autorizzati, perdita o distruzione.
                                </p>

                                <h2>10. Contatti</h2>
                                <p>
                                    Per esercitare i propri diritti o per qualsiasi informazione relativa 
                                    al trattamento dei dati personali, è possibile contattare il titolare 
                                    all'indirizzo email: info@bearsoftware.it
                                </p>

                                <h2>11. Aggiornamenti</h2>
                                <p>
                                    Questa privacy policy può essere aggiornata periodicamente. 
                                    La versione aggiornata sarà pubblicata su questa pagina con 
                                    indicazione della data di ultima modifica.
                                </p>

                                <p className="text-muted mt-4">
                                    <small>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</small>
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default PrivacyPolicy;